import { catalog } from '@nolens/i18n';

/** Formulário para quem testa reportar anomalias (/reportar, ligação no email de boas-vindas). */
export const reportText = catalog(
  {
    docTitle: 'Tell us about a problem · Nolens Guides',
    eyebrow: 'Nolens Guides test',
    title: 'Found a problem or have an idea?',
    lead: 'Tell us what happened. The more detail you give us, the faster we can fix it. A screenshot helps a lot.',
    reportingAs: (who: string) => `You are writing as ${who}.`,
    unknownLink: 'We don’t recognise this link. Please enter the email you signed up with.',
    email: 'Email you signed up with',
    titleLabel: 'In a few words, what’s wrong?',
    titlePlaceholder: 'e.g. The record button does nothing',
    severity: 'How much does it affect you?',
    blocker: 'I can’t work',
    annoying: 'It gets in the way, but I can carry on',
    suggestion: 'It’s a suggestion or an idea',
    description: 'What happened?',
    descriptionPlaceholder: 'What did you expect to happen, and what actually happened?',
    steps: 'How can we reproduce it? (optional)',
    stepsPlaceholder: '1. Open…\n2. Click…\n3. …',
    pageUrl: 'Where did it happen? (optional)',
    pageUrlPlaceholder: 'Page address or name of the application',
    files: 'Attachments (optional)',
    filesHint: 'Up to 5 images (PNG, JPEG, WebP) or PDF files: 10 MB each, 25 MB in total.',
    tooBigTotal: 'The attachments add up to more than 25 MB.',
    tooManyFiles: 'You can attach up to 5 files.',
    tooBig: (name: string) => `The file ${name} is larger than 10 MB.`,
    badType: (name: string) => `The file ${name} is not an image or a PDF.`,
    removeFile: (name: string) => `Remove ${name}`,
    size: (bytes: number) => `${(bytes / 1024 / 1024).toFixed(1)} MB`,
    submit: 'Send report',
    doneTitle: 'Thank you!',
    doneText:
      'We received your message and will look into it carefully. If we need more detail, we will reply by email.',
    another: 'Send another message',
    privacy:
      'We only use this information to improve Nolens Guides. Please avoid screenshots with personal or confidential data.',
  },
  {
    'pt-PT': {
      docTitle: 'Contar-nos um problema · Nolens Guides',
      eyebrow: 'Teste do Nolens Guides',
      title: 'Encontrou um problema ou tem uma ideia?',
      lead: 'Conte-nos o que aconteceu. Quanto mais pormenores nos der, mais depressa conseguimos resolver. Uma captura de ecrã ajuda muito.',
      reportingAs: (who) => `Está a escrever como ${who}.`,
      unknownLink: 'Não reconhecemos esta ligação. Indique o email com que se inscreveu.',
      email: 'Email com que se inscreveu',
      titleLabel: 'Em poucas palavras, o que se passa?',
      titlePlaceholder: 'ex.: O botão de gravar não faz nada',
      severity: 'Quanto é que isto o afeta?',
      blocker: 'Não consigo trabalhar',
      annoying: 'Atrapalha, mas consigo continuar',
      suggestion: 'É uma sugestão ou uma ideia',
      description: 'O que aconteceu?',
      descriptionPlaceholder: 'O que esperava que acontecesse e o que aconteceu de facto?',
      steps: 'Como podemos reproduzir? (opcional)',
      stepsPlaceholder: '1. Abrir…\n2. Clicar…\n3. …',
      pageUrl: 'Onde aconteceu? (opcional)',
      pageUrlPlaceholder: 'Endereço da página ou nome da aplicação',
      files: 'Anexos (opcional)',
      filesHint:
        'Até 5 imagens (PNG, JPEG, WebP) ou ficheiros PDF: até 10 MB cada e 25 MB no total.',
      tooBigTotal: 'Os anexos ultrapassam os 25 MB no total.',
      tooManyFiles: 'Pode juntar até 5 ficheiros.',
      tooBig: (name) => `O ficheiro ${name} tem mais de 10 MB.`,
      badType: (name) => `O ficheiro ${name} não é uma imagem nem um PDF.`,
      removeFile: (name) => `Remover ${name}`,
      size: (bytes) => `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`,
      submit: 'Enviar',
      doneTitle: 'Obrigado!',
      doneText:
        'Recebemos a sua mensagem e vamos analisá-la com atenção. Se precisarmos de mais pormenores, respondemos-lhe por email.',
      another: 'Enviar outra mensagem',
      privacy:
        'Só usamos esta informação para melhorar o Nolens Guides. Evite capturas de ecrã com dados pessoais ou confidenciais.',
    },
  },
);
